import store from 'store'

export const isAppliedMemberSignUpText = () => {
  const hotelIdsRaw = process.env.MEMBER_SIGN_UP_TEXT_HOTEL_IDS || ''
  const hotelIds = hotelIdsRaw.split(',')
  const hotelId = String(store.getters['setting/getHotelId'])
  return hotelIds.includes(hotelId)
}
